import React from 'react';
import { afterPurchase } from '../data/content';
export function AfterPurchase() {
  return <section className="bg-parchment-light text-ink" data-id="element-19" data-mp="21xvazkxc4qkt">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-20" data-mp="21waehprgmxkb">
        <h2 className="text-center font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-21" data-mp="26woeckiwr179">
          {afterPurchase.title}
        </h2>

        <ol className="mx-auto mt-10 grid max-w-md gap-3 md:max-w-none md:grid-cols-2 lg:grid-cols-4 lg:gap-5" data-id="element-22" data-mp="2go2ij5lt0p6q">
          {afterPurchase.steps.map((step, index) => <li key={step.title} className="flex gap-4 rounded-2xl border border-parchment-line bg-white p-5 lg:flex-col lg:gap-4 lg:p-6" data-id="element-23" data-mp="2pnxydnqb18d3" data-mpi={index}>
              <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-leaf font-display text-base font-semibold text-white" data-id="element-24" data-mp="2uky39vbf452m">
                {index + 1}
              </span>
              <div data-id="element-25" data-mp="10auhpffrlfei">
                <h3 className="font-display text-lg font-semibold leading-snug text-ink" data-id="element-26" data-mp="wrqgp3fgb99y">
                  {step.title}
                </h3>
                <p className="mt-1 font-sans text-[0.95rem] leading-relaxed text-ink-soft" data-id="element-27" data-mp="s0gte9hdki18">
                  {step.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}